import { Mode } from "..";
import { SingleCooperativeDetails } from "../../../../../redux/features/cooperative/cooperative.type";
import { PermissionCode } from "../../../../../redux/features/settings/settings.type";
import { CooperativeMemberContributionsView } from "./member";
import { CooperativeOfficialContributionsView } from "./official";

export const CooperativeSavings = ({
  cooperativeDetails,
  mode,
  permissions,
}: {
  cooperativeDetails: SingleCooperativeDetails;
  mode: Mode;
  permissions: PermissionCode[];
}) => {
  return (
    <>
      {mode === "admin" ? (
        <CooperativeOfficialContributionsView
          isProductActive
          permissions={permissions}
          cooperativeDetails={cooperativeDetails}
        />
      ) : (
        <CooperativeMemberContributionsView
          cooperativeDetails={cooperativeDetails}
        />
      )}
    </>
  );
};
